import RcsUtils from './RcsUtils';

class ArticleDetail {
  /**
   * Manage the show/hide of a particular type of articles for mobile "Read more".
   * @param container DOMElement
   */
  static detailArt(container) {
    if (container === null) {
      return;
    }

    let detailsElements = Array.from(container.querySelectorAll('#toggleDetail'));
    let readMoreElement = Array.from(container.querySelectorAll('.readmore'));
    let wrapperElements = Array.from(container.querySelectorAll('.hdr_bkwrapper'));

    wrapperElements.forEach(element => {
      let toggleDetailElement = element.querySelector('#toggleDetail');

      if (toggleDetailElement !== null) {
        let detailsArtElement = element.querySelector('.art_paragraph .art_link');

        if (detailsArtElement === null) {
          toggleDetailElement.style.display = 'none';
        }
      }

      let openCloseDetailsElement = element.querySelector('.relatedContent');
      if (
        openCloseDetailsElement !== null &&
        openCloseDetailsElement.getAttribute('rel') === 'true'
      ) {
        let event = document.createEvent('HTMLEvents');
        event.initEvent('click', true, false);
        toggleDetailElement.dispatchEvent(event);
      }
    });

    readMoreElement.forEach(element => {
      element.addEventListener('click', () => {
        let previousElement = element.previousElementSibling;
        let event = document.createEvent('HTMLEvents');
        event.initEvent('click', true, false);
        previousElement.dispatchEvent(event);
      });
    });

    detailsElements.forEach(element => {
      element.addEventListener('click', () => {
        let nameClass = element.getAttribute('class');
        let parentElement = element.parentNode;

        if (nameClass === 'icon-rowUp') {
          RcsUtils.removeClass(element, 'icon-rowUp');
          RcsUtils.addClass(element, 'icon-rowDown');
          parentElement.querySelector('.readmore').style.display = 'block';
          parentElement.querySelector('.art_paragraph').style.display = 'none';
        } else {
          RcsUtils.removeClass(element, 'icon-rowDown');
          RcsUtils.addClass(element, 'icon-rowUp');
          parentElement.querySelector('.readmore').style.display = 'none';
          parentElement.querySelector('.art_paragraph').style.display = 'block';
        }
      });
    });
  }
}

module.exports = ArticleDetail;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/utils/ArticleDetail.js